module.exports = __webpack_public_path__ + "img/22.fb20deb9.png";